import { Injectable } from '@angular/core';
import { Notification, RidangoReduxAction } from './../ridango.models';

@Injectable( { providedIn: 'root' } )
export class NotificationActions {
    static ADD_NOTIFICATION = '[Core]: Add notification';
    static ADD_GROUPED_NOTIFICATION = '[Core]: Add grouped notification';
    static REMOVE_NOTIFICATION = '[Core]: Remove notification';
    static REMOVE_ALL_NOTIFICATIONS = '[Core]: Remove all notifications';
    addNotification ( payload: Notification ): RidangoReduxAction {
        return {
            type: NotificationActions.ADD_NOTIFICATION,
            payload: payload
        };
    }

    addGroupedNotification(payload: Notification): RidangoReduxAction {
        return {
            type: NotificationActions.ADD_GROUPED_NOTIFICATION,
            payload: payload
        };
    }

    removeAllNotifications(): RidangoReduxAction {
        return {
            type: NotificationActions.REMOVE_ALL_NOTIFICATIONS
        };
    }
}



